<template>
  <div>
    <div class="row mt-50">
      <div class="col-md-8 col-md-offset-2">
        <div class="card" id="wizardCard">
          <form-wizard shape="circle"
                       stepSize="xs"
                       ref="wizard"
                       @on-change="scrollToTop"
                       :error-color="primary"
                       :title="title"
                       :subtitle="computeCaption(fields_en['kit_registration'], this.$store.state.lang.value.toLowerCase())"
                       :color='primary'>

            <tab-content :title="computeCaption(fields_en['site'], this.$store.state.lang.value.toLowerCase())"
                         :before-change="validateFirstStep"
                         route="/patient/kit/site"
                         icon="">
              <first-step ref="firstStep"
                          v-on:jumpToTheNextPage="jumpToTheNextPage">
              </first-step>
            </tab-content>

            <tab-content v-if="allow_disclaimer"
                         :title="computeCaption(fields_en['disclaimer'], this.$store.state.lang.value.toLowerCase())"
                         :before-change="validateSecondStep"
                         route="/patient/kit/disclaimer"
                         icon="">
              <second-step ref="secondStep"
                           v-on:nextTab="nextTab">
              </second-step>
            </tab-content>

            <tab-content :title="computeCaption(fields_en['medical_data'], this.$store.state.lang.value.toLowerCase())"
                         :before-change="validateThirdStep"
                         route="/patient/kit/medical-data"
                         icon="">
              <third-step ref="thirdStep"
                           v-on:nextTab="nextTab">
              </third-step>
            </tab-content>

            <tab-content :title="computeCaption(fields_en['scan_kit'], this.$store.state.lang.value.toLowerCase())"
                         :before-change="validateFourthStep"
                         route="/patient/kit/scan"
                         icon="">
              <fourth-step ref="fourthStep"
                          v-on:nextTab="nextTab"
              ></fourth-step>
            </tab-content>

            <button slot="prev" class="btn btn-default btn-fill btn-wd btn-back"><span>{{computeCaption(fields_en['back'], this.$store.state.lang.value.toLowerCase())}}  </span></button>
            <button slot="next" class="btn btn-fill btn-wd btn-next"><span> {{ computeCaption(fields_en['next'], this.$store.state.lang.value.toLowerCase())}}</span></button>
            <button slot="finish" class="btn btn-info btn-fill btn-wd display-none">{{ computeCaption(fields_en['i_agree_and_submit'], this.$store.state.lang.value.toLowerCase())}}</button>

          </form-wizard>
          <div class="row">
            <div class="col-md-12">
              <p v-if="allow_results || allow_registration || allow_kit" class="m-50">
                <a v-if="allow_registration" aria-label="Link to registration" href='#' role="link" v-on:click.stop.prevent="$router.push({path:'/patient/register'})" class="primary-color">{{ computeCaption(fields_en['registration'], this.$store.state.lang.value.toLowerCase()) }}</a>  <a v-if="allow_results">|</a>
                <a v-if="allow_results" aria-label="Link to check results" href='#' role="link" v-on:click.stop.prevent="$router.push({path:'/patient/check-results'})" class="primary-color">{{ computeCaption(fields_en['results'], this.$store.state.lang.value.toLowerCase())}}</a>
                </p>
            </div>
          </div>
          <br><br>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import variables from '../../../../assets/sass/paper/_variables.scss'
  import {FormatterUtils} from '../../../../utils/Formatter.js'
  import FirstStep from './Wizard/SiteSelectionStepKit.vue'
  import SecondStep from './Wizard/Disclaimer.vue'
  import ThirdStep from './Wizard/Data.vue'
  import FourthStep from './Wizard/ScanKit.vue'
  import {TranslationsUtils} from '../../../../utils/Translations'
  // import SixthStep from './Wizard/SubmissionStep.vue'
  // import swal from 'sweetalert2'
  // import axios from 'axios'

  export default {
    data () {
      return {
        primary: variables.primaryColor,
        secondary: variables.secondaryColor,
        configsReady: false,
        submit: false,
        fields_en: {
          scan_kit: 'Scan Kit',
          next: 'Next',
          back: 'Back',
          i_agree_and_submit: 'I Agree and Submit',
          kit_registration: 'Kit Registration',
          site: 'Site',
          medical_data: 'Medical Data',
          disclaimer: 'Disclaimer',
          payment_information: 'Payment Information',
          submission: 'Submission',
          check_your_results: 'Check your results',
          here: 'here',
          consent: 'Consent',
          results: 'Check your results',
          registration: 'Register as a new patient',
          kit: 'Register kit'
        },
        disabled: false,
        wizardModel: {}
      }
    },
    mixins: [FormatterUtils, TranslationsUtils],
    components: {
      FirstStep,
      SecondStep,
      ThirdStep,
      FourthStep
    },
    mounted: function () {
      window.document.title = this.title + ' Register Kit - Site Code Step'
      this.$sidebar.isMinimized = true
    },
    // async beforeCreate () {
    //   axios.get(process.env.SERVER_URI + '/conf/kit')
    //     .then((response) => {
    //       this.$store.state.configs = response.data
    //       this.configsReady = true
    //     }).catch((e) => {
    //       console.log('There was an error' + e)
    //     })
    // },
    methods: {
      nextTab () {
        this.$refs.wizard.nextTab()
      },
      jumpToTheNextPage () {
        // this method will jump to the next page without any validation
        // do not use it
        this.$refs.wizard.changeTab(0, 1)
      },
      validateFirstStep () {
        return this.$refs.firstStep.validate()
      },
      validateSecondStep () {
        return this.$refs.secondStep.validate()
      },
      validateThirdStep () {
        return this.$refs.thirdStep.validate()
      },
      validateFourthStep () {
        return this.$refs.fourthStep.validate()
      },
      validateFifthStep () {
        return this.$refs.fifthStep.validate()
      },
      validateSixthStep () {
        return this.$refs.sixthStep.validate()
      },
      scrollToTop () {
        let elmnt = document.getElementsByClassName('main-panel')[0]
        let buttons = document.getElementsByClassName('btn-fill')
        // reset focus from the buttons after each step
        for (let i = 0; i < buttons.length; i++) {
          buttons[i].blur()
        }
        elmnt.scrollTo(0, 0)
        this.$refs.wizard.tabs.forEach(element => {
          if (element.active) {
            window.document.title = this.title + ' ' + element.title + ' Step'
          }
        })
      }
    },
    computed: {
      allow_disclaimer () {
        return this.$store.state.configs.ALLOW_KIT_DISCLAIMER
      },
      // title () {
      //   return this.$store.state.configs.LAB_NAME
      // },
      title () {
        return this.$store.state.configs.LAB_NAME
      },
      allow_results () {
        return this.$store.state.configs.ALLOW_RESULTS
      },
      allow_registration () {
        return this.$store.state.configs.ALLOW_REGISTRATION
      },
      allow_kit () {
        return this.$store.state.configs.ALLOW_KIT_REGISTRATION
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../../assets/sass/paper/_variables.scss';
  .vue-form-wizard .wizard-nav-pills>li>a {
    color: $primary-color;
  }

  .vue-form-wizard .wizard-nav-pills>li>a.disabled {
    color: $secondary-color;
  }

  .m-50{
    margin-top: 20px;
    padding-bottom: 20px;
    margin-left: 20px;
  }

  .display-none{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/RegistrationKit/RegistrationKitWizard.vue